import React, { useEffect, useState } from "react";
import getServices from "../../Services/getServices";
import PropertyComponent from "./PropertyComponent";
import House from "../../Assets/images/house2.png";
import EmptyStateGif from "../../Assets/gif/gif.gif";
function NewInvestment() {
  const [data, setData] = useState([]);
  let counter = 0;
  const getData = () => {
    getServices
      .getAllInvestments()
      .then((response) => {
        setData(response.data.data.reverse());
      })
      .catch((error) => {});
  };
  useEffect(() => {
    getData();
  }, []);
  const filteredData = data.filter((item) => item.projectStatus === "active");
  return (
    <div className=" px-2 md:px-20 bg-[#FAFAFA] p-4 my-10 ">
      <h1 className=" text-[16px] md:text-[40px] font-[800] wow  animate__animated animate__fadeInLeft text-[#1E222B]">
        New Investment opportunities
      </h1>
      <div className=" mt-6">
        {filteredData.map((items, index) => {
          if (counter < 3) {
            counter++;
            return (
              <div key={index}>
                <PropertyComponent
                  name={items.projectName}
                  type={items.projectType}
                  ppu={items.pricePerUnit}
                  roi={items.totalInvestors}
                  perc={items.percentSold}
                  invested={items.pricePerUnit * items.unitSold}
                  leftinvest={items.pricePerUnit * items.unitAvailable}
                  img={items.imageUrl[0] ?? House}
                  daysleft={items.endDate ?? "2024-06-08T16:00:00.000+00:00"}
                />
              </div>
            );
          }
          return null;
        })}
      </div>
      {filteredData.length === 0 && (
        <div className="flex flex-col items-center justify-center py-10">
          <img
            src={EmptyStateGif}
            alt="No active investment currently"
            className="w-48 h-48 object-contain"
          />
          <p className="text-center text-gray-500 text-xl mt-4">
            Any recent investment will appear here
          </p>
        </div>
      )}
    </div>
  );
}

export default NewInvestment;
